import styles from './TrackingProgressBar.module.scss';

type TrackingProgressBarProps = {
  progress?: number;
  variant?: 'animated' | 'static' | 'completed';
};

const VARIANT_STYLES: Record<NonNullable<TrackingProgressBarProps['variant']>, string> = {
  animated: styles.progressFill,
  static: styles.progressFillStatic,
  completed: styles.progressFillCompleted,
};

export const TrackingProgressBar = ({ progress = 0, variant = 'animated' }: TrackingProgressBarProps) => {
  const progressFillClass = VARIANT_STYLES[variant];

  return (
    <div className="w-full h-1.5 rounded-full overflow-hidden bg-[rgba(120,120,120,0.2)]">
      <div className={`${progressFillClass} h-full relative rounded-full`} style={{ width: `${progress}%` }} />
    </div>
  );
};
